
import { Component, Ref, Vue, Watch, Prop } from 'vue-property-decorator';

// Utils
import { getCurrentDateString } from '@/utils/Helper';
import ErrorService from '@/utils/ErrorService';
import { downloadFile } from '@/utils/FilesDownloading';

// Components
import VModalGeneral from '@/components/VModal/VModalGeneral.vue';
import VButton from '@/components/VButton/VButton.vue';
import VDatePicker from '@/components/VDatePicker.vue';
import VTextarea from '@/components/VTextarea.vue';

@Component({
    components: {
        VDatePicker,
        VButton,
        VModalGeneral,
        VTextarea,
    },
})
export default class VModalCreateReport extends Vue {
    @Ref() modal!: VModalGeneral;
    @Ref() fromDatePicker!: VDatePicker;
    @Ref() toDatePicker!: VDatePicker;

    @Prop({ type: Boolean, default: false }) isAcceptance!: boolean;
    @Prop({ type: Boolean, default: false }) isDesignReport!: boolean;

    getCurrentDateString = getCurrentDateString;

    fromDate: string = '';
    fromDatePickerMax = '';
    hasValidationAttempt = false;
    toDate: string = '';
    toDatePickerMin = '';

    get isValid() {
        return this.fromDate && this.toDate;
    }

    @Watch('fromDate', { immediate: true })
    fromDateHandler() {
        if (this.toDatePicker) {
            this.toDatePickerMin = this.fromDate;
        }
    }

    @Watch('toDate', { immediate: true })
    toDateHandler() {
        if (this.fromDatePicker) {
            this.fromDatePickerMax = this.toDate;
        }
    }

    show() {
        this.modal.showModal();
    }

    hide() {
        this.toDate = '';
        this.fromDate = '';
        this.modal.hideModal();
    }

    async createReport() {
        let url = '';
        let name = '';

        if (!this.isAcceptance && !this.isDesignReport) {
            url = `designs/task/get/statistic?fromDate=${this.fromDate}&toDate=${this.toDate}`;
            name = this.$t('page.designing.task.createReportFileName', [this.fromDate, this.toDate]) as string;
        }

        if (this.isAcceptance && !this.isDesignReport) {
            url = `violations-acceptance/get/statistic?fromDate=${this.fromDate}&toDate=${this.toDate}`;
            name = this.$t('page.designing.task.createReportFileNameAcceptance', [
                this.fromDate,
                this.toDate,
            ]) as string;
        }

        if (this.isDesignReport) {
            url = `designs/get/expiried?fromDate=${this.fromDate}&toDate=${this.toDate}`;
            name = this.$t('page.designing.task.createReportVerification', [this.fromDate, this.toDate]) as string;
        }

        try {
            const fileData = {
                url,
                name,
            };

            await downloadFile(fileData);
        } catch (error) {
            ErrorService.handleApiError(error);
        } finally {
            this.hide();
        }
    }
}
